/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import inbox from './inbox';
import document from './documents';

const reducer = combineReducers({
  inbox,
  document,
});

const configureStore = (initialState = {}) => {
  return createStore(reducer, initialState, compose(applyMiddleware(thunk)));
};

export { configureStore };
